import { render, staticRenderFns } from "./HomeData.vue?vue&type=template&id=81ab4eb8&scoped=true"
import script from "./HomeData.vue?vue&type=script&lang=js"
export * from "./HomeData.vue?vue&type=script&lang=js"
import style0 from "./HomeData.vue?vue&type=style&index=0&id=81ab4eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ab4eb8",
  null
  
)

export default component.exports